 $(document).on("click", ".pop_open_button", function() {
        var self = this; // 保存当前上下文
        var checkoutIntervalpop = setInterval(function() {
            if ($('.product-pop').length > 0) {
                clearInterval(checkoutIntervalpop);
                var contentHTML = $(self).attr('data-content');               
                var popid = $(self).attr('data-section-id'); 
                $('.product-pop .product-pop-data').html(contentHTML);
                $('.product-pop').addClass('open');
                $('.product-pop').attr('id', popid);
                $('body').addClass('no-scroll');   
              
              // 检查屏幕宽度
            // const width = window.innerWidth;
            // if (width < 767) {
            //     var swiper = new Swiper('.why-choose-swiper', {
            //         slidesPerView: "auto",
            //         spaceBetween: 10,
            //         freeMode: true, // 启用自由模式
            //         speed: 600,
            //         pagination: {
            //             el: '.swiper-pagination',
            //             clickable: true,
            //         },
            //     });
            // }
              
            } else {
                console.log("..popbox");
            }
        }, 100);
   
    //  if ($(this).hasClass("why-pop-data_button") || $(this).find(".why-pop-data_button").length) {
    //       gtag('event', 'WHY_CHOOSE_TYMO');
    //   }
   
    });

    $(document).on("click", ".closefold", function() {
    $('body').removeClass('no-scroll');  
        $('.product-pop').removeClass('open');
        $('.product-pop').removeAttr('id');
    });

    $(document).on("click", ".product-pop-overlayer", function() {
    $('body').removeClass('no-scroll');  
        $('.product-pop').removeClass('open');
        $('.product-pop').removeAttr('id');
    });


 (function () {

    const host = window.location.hostname;

    if (host === "tymobeauty.live") {

      const newUrl =
        "https://www.tymobeauty.jp" +
        window.location.pathname +
        window.location.search;

      window.location.replace(newUrl);
    }

  })();